module.exports = __webpack_public_path__ + "media/Cori_Pairing-Mode_Light.eebeda4b.mp4";